<button type="button" #hackButton class="d-none">
  NÃO REMOVER ESTE BOTÃO!!! Este botão deve existir para fazer com que a caixa
  de seleção de imagens não seja aberta ao clicar em qualquer parte do
  componente.
</button>
<input
  #fileInput
  id="fileInput"
  type="file"
  accept="image/*"
  (change)="addFile()"
  style="display: none"
/>
<div class="text-center avatar-container" style="position: relative">
  <div
    class="img-circle bg-white"
    [class.avatar-wrapper]="!fluid"
    [class.avatar-fluid-wrapper]="fluid"
    [class.avatar-radius]="!square"
    [class.avatar-wrapper-error]="!isValid() && isRequired()"
  >
    @if (!isValid()) {
      <div class="avatar-flex">
        <i style="transform: scale(4.5)" class="{{ icone }}"></i>
      </div>
    }
    @if (isValid()) {
      <img
        [src]="value"
        [onStock]="isSvg"
        [class.avatar]="!fluid"
        [class.avatar-fluid]="fluid"
      />
    }
    @if (isLoading) {
      <mat-spinner
        [diameter]="80"
        class="position-absolute"
        style="z-index: 99; top: 35px; left: 35px"
      ></mat-spinner>
    }
  </div>

  <button
    mat-mini-fab
    type="button"
    (click)="changeFile()"
    tabindex="-1"
    class="avatar-btn"
    [disabled]="disabled"
  >
    <i class="far fa-camera"></i>
  </button>

  <button
    mat-button
    type="button"
    #menuTrigger="matMenuTrigger"
    [disabled]="disabled"
    [matMenuTriggerFor]="menu"
    style="opacity: 0"
  >
    Menu
  </button>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="openFile()">
      <i class="far fa-sync me-2"></i> Alterar
    </button>
    <button mat-menu-item (click)="removeFile()">
      <i class="far fa-trash me-2"></i> Remover
    </button>
  </mat-menu>
</div>
